import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';

import I18nLink from '../../widgets/I18nLink';

import './NotFoundPage.css';

class NotFoundPage extends PureComponent {
  componentWillMount() {
    if (typeof global !== 'undefined') {
      global.notFound = true;
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div className="not-found-page">
        <div className="not-found-page-container">
          <h2>{t('Error 404')}</h2>
          <h1>{t('Page not found')}</h1>
          <p>
            {t('It is possible that it was deleted or just an invalid link')}.<br/>
            {t('Check the link address or start from the main page')}.
          </p>
          <I18nLink to="/">
            <Button bsStyle="success">
              {t('Go to main page')}
            </Button>
          </I18nLink>
        </div>
      </div>
    );
  }
}

export default translate(['404'])(NotFoundPage);



// WEBPACK FOOTER //
// ./src/components/NotFoundPage/NotFoundPage.jsx